import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import SearchBarList from './list';
import SearchBarInput from './input';
import Text from '../text';

var SearchBar = function SearchBar(_ref) {
  var asModal = _ref.asModal,
      children = _ref.children,
      className = _ref.className,
      isExpanded = _ref.isExpanded,
      _onClick = _ref.onClick;

  if (asModal) {
    return React.createElement("div", {
      className: classNames('search-modal', className, {
        'is-expanded': isExpanded
      })
    }, React.createElement("div", {
      className: "modal-background",
      onClick: function onClick(e) {
        // this.setState({ isExpanded: !isExpanded })
        _onClick && _onClick(e);
      }
    }), children && typeof children.valueOf() === 'string' ? React.createElement(SearchBar.Text, {
      content: children
    }) : children);
  } // render inline


  return React.createElement("div", {
    className: classNames('field search-no-modal', className)
  }, children && typeof children.valueOf() === 'string' ? React.createElement(SearchBar.Text, {
    content: children
  }) : children);
};

SearchBar.propTypes = {
  children: PropTypes.any.isRequired,
  asModal: PropTypes.bool.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  isExpanded: PropTypes.bool
};
SearchBar.List = SearchBarList;
SearchBar.Input = SearchBarInput;
SearchBar.Text = Text;
export default withModifiers(SearchBar);